import { CurvedDivider } from '#components/CurvedDivider';
import { ParallaxSection } from '#components/ParallaxSection';
import ProductShowcase from '#sections/ProductShowcase';
import SocialProofBar from '#sections/SocialProofBar';
import {
  Box,
  Container,
  Heading,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';

function SolutionsPage() {
  const headingColor = useColorModeValue('gray.900', 'white');
  const subColor = useColorModeValue('gray.600', 'gray.300');
  const bgColor = useColorModeValue('gray.50', 'gray.900');

  return (
    <>
      {/* Page Hero */}
      <Box
        bg={bgColor}
        pt={{ base: 16, md: 24 }}
        pb={{ base: 8, md: 12 }}
        borderBottom="1px solid"
        borderColor={useColorModeValue('gray.200', 'gray.700')}
      >
        <Container maxW="container.xl" textAlign="center">
          <Heading
            as="h1"
            fontSize={{ base: '3xl', md: '5xl' }}
            fontWeight="extrabold"
            color={headingColor}
            letterSpacing="-0.03em"
            lineHeight="1.1"
            mb={4}
          >
            Three products.
            <br />
            One platform.
            <br />
            Zero operational friction.
          </Heading>
          <Text
            fontSize={{ base: 'lg', md: 'xl' }}
            color={subColor}
            maxW="2xl"
            mx="auto"
            mt={4}
          >
            We don't build bespoke IT projects. We install proven, reusable
            modules and configure them around your specific business process.
            Every client gets the same platform — the results are yours alone.
          </Text>
        </Container>
      </Box>

      {/* Social Proof Stats */}
      <SocialProofBar />

      <CurvedDivider />

      {/* Product Cards */}
      <ParallaxSection offsetY={20}>
        <ProductShowcase />
      </ParallaxSection>

      <CurvedDivider flip />
    </>
  );
}

export default SolutionsPage;
